<template>
  <figure style="width: 100%; height: 100%;display: flex;align-items: center;justify-content: center;">
    <chart :options="chartOptions" style='width: 100%; height: 100%' ref="polar" auto-resize v-if="dataState === 'ready'"></chart>
    <template v-else-if="dataState === 'loading'">
      <center>
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </center>
    </template>
    <template v-else-if="dataState === 'noData'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
    </template>
    <template v-else-if="dataState === 'error'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
    </template>
  </figure>
</template>

<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/polar'
import 'echarts/lib/component/tooltip'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataState: 'loading',
      chartOptions: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          data: ['Articles', 'Tweets']
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              color: '#424242',
              fontSize: 10
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: 'Articles',
            min: 0,
            max: 0,
            minInterval: 1
          },
          {
            type: 'value',
            name: 'Tweets',
            min: 0,
            max: 0,
            minInterval: 1
          }
        ],
        series: [
          {
            name: 'Articles',
            type: 'bar',
            data: []
          },
          {
            name: 'Tweets',
            type: 'bar',
            data: []
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getQuery', 'getFilters'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setCustomFilters']),
    setCountry: function (value) {
      if (value.data.id) {
        if (this.chartOptions.series[0].data.length === 1) {
          this.setCustomFilters({countryId: []})
          this.$store.commit('setSelectedCountries', [])
        } else {
          this.setCustomFilters({countryId: value.data.id})
        }
      }
    },
    getData: function () {
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getStories', this.getQuery({sortBy: '_article_count', order: 'desc', pageSize: 10}))
      ]).then(axios.spread((r1) => {
        if (r1.data.status === 'SUCCESS') {
          var dataArray = []
          var dataArrayStories = []
          var dataArrayTweets = []
          var baselineY1 = 0
          var baselineY2 = 0
          for (var i = 0; i < r1.data.payload.length; i++) {
            var articles = r1.data.payload[i].articleCount ? r1.data.payload[i].articleCount : 0
            baselineY1 = articles > baselineY1 ? articles : baselineY1
            var tweets = r1.data.payload[i].tweetCount ? r1.data.payload[i].tweetCount : 0
            baselineY2 = tweets > baselineY2 ? tweets : baselineY2
            dataArray.push({value: articles, tweets: tweets})
            dataArrayStories.push({value: r1.data.payload[i].title})
            dataArrayTweets.push({value: tweets, articles: articles})
          }
          this.chartOptions.series[0].data = dataArray
          this.chartOptions.series[0].yAxisIndex = 0
          this.chartOptions.series[1].data = dataArrayTweets
          this.chartOptions.series[1].yAxisIndex = 1
          this.chartOptions.xAxis[0].data = dataArrayStories
          this.chartOptions.yAxis[0].max = baselineY1 + (5 - (baselineY1 % 5))
          this.chartOptions.yAxis[1].max = baselineY2 + (5 - (baselineY2 % 5))
          if (r1.data.payload.length > 0) {
            this.dataState = 'ready'
          } else {
            this.dataState = 'noData'
          }
        } else {
          this.dataState = 'error'
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (!underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.getData()
        }
      }
    },
    loading: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal === true) {
          let scatter = this.$refs.scatter
          if (scatter) {
            scatter.showLoading({
              text: '',
              color: '#4ea397',
              maskColor: 'rgba(255, 255, 255, 0.4)'
            })
          }
        } else {
          let scatter = this.$refs.scatter
          if (scatter) {
            scatter.hideLoading()
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/ArticlesAndTweetsPerStory.vue